<template>
    <!-- 对话框 -->
    <el-drawer title="添加畅行卡信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="60%"
      :wrapperClosable="true">
  
      <!-- 基本信息表单 -->
      <div class="form-box">
  
        <template>
  
          <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">
            <el-form-item label="名称:" label-width='160px'>
                <div class="lable-fontcolor">{{submit_data.name}}</div>
            </el-form-item>

            <el-form-item label="售价（元）:" label-width='160px'>
                <div class="lable-fontcolor">{{submit_data.price}}</div>
            </el-form-item>

            <el-form-item label="限制次数:" label-width='160px'>
                <div class="lable-fontcolor">{{submit_data.limit_num}}</div> 
            </el-form-item>

            <el-form-item label="有效期(天):" label-width='160px'>               
                <div class="lable-fontcolor">{{submit_data.expire}}</div>              
            </el-form-item>

            <el-form-item label="指定订单模式:" label-width='160px'>
                <div class="lable-fontcolor">{{submit_data.order_modes}}</div>             
            </el-form-item>         
  
            <el-form-item label="抵扣规则:" label-width='160px'>
                <div class="lable-fontcolor">{{submit_data.type == '0'?'免起步价格':'免订单金额'}}</div> 
            </el-form-item>
  
            <el-form-item label="一口价模式是否可用:" label-width='160px'>
                <div class="lable-fontcolor">{{submit_data.kilo_step_mode == '1'?'可用':'禁用'}}</div>  
            </el-form-item>
  
            <el-form-item label="短途特惠是否可用:" label-width='160px'>
                <div class="lable-fontcolor">{{submit_data.short_distance == '1'?'可用':'禁用'}}</div>  
            </el-form-item>
            <el-form-item label="是否限制新用户:" label-width='160px'>
                <div class="lable-fontcolor">{{submit_data.is_new_visit == '1'?'是':'否'}}</div>  
            </el-form-item>
            <el-form-item label="是否完善个人信息:" label-width='160px'>
                <div class="lable-fontcolor">{{submit_data.is_perfect_user == '1'?'是':'否'}}</div>  
            </el-form-item>
  
  
            <el-form-item label="司机承担金额:" label-width='160px'>
                <div class="lable-fontcolor">{{submit_data.driver_deduct}}</div> 
            </el-form-item>
  
            <el-form-item label="其他说明:" label-width='160px'>
                <div v-html="submit_data.remark" class="lable-fontcolor"></div>              
            </el-form-item>
          </el-form>
  
          <!-- 对话框底部按钮 -->
          <div style="display: flex;justify-content: center;margin-top: 20px;">
  
  
            <el-button @click="closeDialog">关闭</el-button>
          </div>
  
        </template>
  
      </div>
  
    </el-drawer>
  </template>
  
  <script>
    var _this;
  
    export default {
  
      props: {
        isShow: Boolean,
        data: ''
      },
      watch: {
        isShow(newData, oldData) {
  
          _this.show = true;
          _this.card_code = _this.data;
        
          
        //   请求详情接口
          _this.viewCard()
  
         
        },
      },
      data() {
        return {
          show: false,
          card_code: '',
          // 表单数据
          submit_data: {
            // 优惠券名称
            name: '',
            limit_num: '',
            expire: '',
            kilo_step_mode: '',
            type: '',
            price: '',
            short_distance: '',
            is_new_visit: '',
            is_perfect_user: '',
            driver_deduct: '',
            remark: '',  
            order_modes: ''      
          },
          
  
          
        };
      },
      created() {
        _this = this;
  
  
      },
      methods: {

         //优惠券详情
         viewCard(){
                _this.$post(
                    "/card/viewCard",{
                        card_code:_this.card_code,
                       
                    },
                ).then(res => {                   
                    _this.submit_data.name = res.data.name;
                    _this.submit_data.type = res.data.type;
                    _this.submit_data.order_modes = res.data.order_modes;
                    _this.submit_data.kilo_step_mode = res.data.kilo_step_mode;
                    _this.submit_data.expire = res.data.expire;
                    _this.submit_data.limit_num = res.data.limit_num;
                    _this.submit_data.amount = res.data.amount;
                    _this.submit_data.price = res.data.price;
                    _this.submit_data.discount = res.data.discount;
                    _this.submit_data.ceiling_amount = res.data.ceiling_amount;
                   
                    _this.submit_data.short_distance = res.data.short_distance;
                    _this.submit_data.is_new_visit = res.data.is_new_visit;
                    _this.submit_data.is_perfect_user = res.data.is_perfect_user;
                    _this.submit_data.driver_deduct = res.data.driver_deduct;
                    _this.submit_data.voucher_description = res.data.voucher_description;
                    _this.submit_data.remark = res.data.remark;
                    


                }).catch((err) => {

                })
                

            },
        
  
        
        // 关闭方法
        closeDialog() {
          _this.show = false;
        },
  
  
  
      },
    };
  </script>
  
  <style scoped>
    .lable-fontcolor{
        color: #606266;
    }
    .form-box {
      padding: 20px;
      box-sizing: border-box;
      margin-right: 0;
      width: 100%;
    }
  
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
  
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
  
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
  
    .avatar {
      width: 100px;
      height: 100px;
      display: block;
    }
  
    .el-form-second {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }
  
    .avatar-uploader {
      width: 100px;
      height: 100px;
    }
  
    .avatar-uploader img {
      display: block;
      width: 100%;
      height: 100%;
    }
  
    .verify_remarks {
      font-size: 14px;
      color: #606266;
    }
  
    .quill-editor {
      width: 80%;
    }
  </style>